/**
 * TanStack Query keys for caches that are read in one hook and written in
 * another. Keeping them here avoids duplicating key literals (a typo silently
 * turns an invalidation into a no-op) and avoids import cycles between hooks
 * that compose each other.
 */

/**
 * Prefix for the `pipeline_stage_history` cache. Pass this to
 * `invalidateQueries` to hit every deal-id-set variant at once — a full key
 * carries the id set, which the writer usually doesn't know.
 */
export const STAGE_HISTORY_QUERY_PREFIX = ["pipeline_stage_history"] as const;

/**
 * Full stage-history key. `dealIdsKey` is the sorted, `|`-joined set of
 * `pipeline_properties` ids the history is fetched for — the result only
 * changes when that set does, so it belongs in the key.
 */
export function stageHistoryQueryKey(
  workspaceId: string | undefined,
  dealIdsKey: string,
) {
  return [...STAGE_HISTORY_QUERY_PREFIX, workspaceId, dealIdsKey] as const;
}
